import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/denied/usage.deniedFeature.query.gql"
import type {
  UsageLicenseDeniedFeatureQuery,
  UsageLicenseDeniedFeatureQueryVariables,
} from "@/v2-backoffice-client/usage/denied/__types__/usage.deniedFeature.query"

type Options = QueryHookOptions<
  UsageLicenseDeniedFeatureQuery,
  UsageLicenseDeniedFeatureQueryVariables
>

export function useUsageLicenseDeniedFeatureQuery(options?: Options) {
  return useQuery<
    UsageLicenseDeniedFeatureQuery,
    UsageLicenseDeniedFeatureQueryVariables
  >(query, options)
}
